import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    BenefitTaxDto, BenefitTaxPaginator,
    CreateBenefitTaxDto,
    CreateCompanyBenefitTaxDto, QueryBenefitTaxDto,
    UpdateBenefitTaxDto
} from "../models/benefit-tax.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetCompanyBenefitTax(companyId: number, options?: QueryBenefitTaxDto, queryOptions?: any) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_BENEFIT_TAX.GET;
    const request = API.ProcessingCompanyAPI.getCompanyBenefitTax(companyId, options);

    const { data, isLoading, error, refetch } = useQuery<BenefitTaxPaginator, Error>(
        [url, options],
        (() => request),
        {...API.Handlers.pageParamOption, ...queryOptions}
    );

    return { data, isLoading, error, refetch };
}

export function useGetCompanyBenefitTaxById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_BENEFIT_TAX.DETAIL;
    const request = API.ProcessingCompanyAPI.getCompanyBenefitTaxById(companyId, id);

    const { data, isLoading, error, refetch } = useQuery<{ data:BenefitTaxDto }, Error>(
        [url, companyId, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return { data, isLoading, error, refetch };
}
export function useCreateCompanyBenefitTax() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ companyId, payload }: {companyId: number, payload: CreateCompanyBenefitTaxDto}) => API.ProcessingCompanyAPI.createCompanyBenefitTax(companyId,payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_BENEFIT_TAX.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateCompanyBenefitTax() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateBenefitTaxDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateCompanyBenefitTax(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_BENEFIT_TAX.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteCompanyBenefitTax() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ companyId, id }: { companyId: number, id: number }) => API.ProcessingCompanyAPI.deleteCompanyBenefitTax(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_BENEFIT_TAX.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}